import { render, staticRenderFns } from "./RankingCard.vue?vue&type=template&id=0da263ab"
import script from "./RankingCard.vue?vue&type=script&lang=js"
export * from "./RankingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports